import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'patient-tabs',
    templateUrl: './patient-tabs.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PatientTabsComponent implements OnInit {
    patientsMenu: Array<MenuItem>;
    @Input() patientId;

    createTabMenu(): void {
        this.patientsMenu = [
            { label: 'Appointments', routerLink: 'appointments', queryParams: {'patientid': this.patientId} },
            { label: 'Messages', routerLink: 'messages', queryParams: {'patientid': this.patientId} }
        ];
    }

    ngOnInit(): void {
        this.createTabMenu();
    }

}
